export default "__VITE_ASSET__298ddd0b__"